import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const IndustriesSection = () => {
  const industries = [
    {
      id: 1,
      icon: "Factory",
      title: "Manufacturing",
      description: "Coordinate autonomous robots, AGVs, quality inspection agents, and production line systems"
    },
    {
      id: 2,
      icon: "Car",
      title: "Automotive",
      description: "Orchestrate autonomous vehicle testing, fleet coordination, and ADAS validation workflows"
    },
    {
      id: 3,
      icon: "Ship",
      title: "Maritime",
      description: "Deploy agents across vessels, port infrastructure, and remote monitoring systems"
    },
    {
      id: 4,
      icon: "Shield",
      title: "Defense",
      description: "Coordinate tactical agents, UAVs, C4ISR systems, and ground stations in contested environments"
    }
  ];

  return (
    <section className="py-24 px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <h2 className="text-2xl font-bold text-foreground mb-3 md:mb-4 lg:mb-5">
            Trusted Across Critical Industries
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Engineering teams at scale deploy Sleeve for mission-critical orchestration across diverse domains
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 lg:gap-10">
          {industries?.map((industry) => (
            <div
              key={industry?.id}
              className="group bg-card border border-border rounded-lg p-6 md:p-7 lg:p-8 hover:border-primary/50 transition-all duration-300"
            >
              {/* Icon & Title */}
              <div className="flex items-start gap-4 mb-4 md:mb-5">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-secondary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-secondary/20 transition-colors duration-300">
                  <Icon name={industry?.icon} size={24} color="var(--color-secondary)" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2">
                    {industry?.title}
                  </h3>
                </div>
              </div>

              {/* Description */}
              <p className="text-xs md:text-sm lg:text-base text-muted-foreground leading-relaxed mb-4 md:mb-5">
                {industry?.description}
              </p>

              {/* View Use Cases Link */}
              <Link
                to="/use-cases"
                className="inline-flex items-center gap-2 text-xs md:text-sm text-primary hover:text-primary/80 font-medium transition-colors duration-250"
              >
                View use cases
                <Icon name="ArrowRight" size={14} color="currentColor" />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;